import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class ScheduledTime
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.scheduledTime[0];
* const contactInfo = new ScheduledTime(record);
* @property {NUMBER} _id - The id of the scheduledTime.
* @property {STRING} _type - The value of the scheduledTime like
"start" or "end" or empty ("") if there is only 1 time to set.
* @property {STRING} _hour - The hour of the scheduled time.
* @property {STRING} _minute - The minute of the scheduled time.
* @property {STRING} _timeOfDay - The time of day of the scheduled time, like "AM" or "PM".
*/
export default class ScheduledTime extends BCMSRecord {
    _id
    _type
    _hour
    _minute
    _timeOfDay

    constructor (record){     
      super(record) 
    }
  }
  ScheduledTime.define({
    "recordType":"scheduledTimes",
    "recordIDProp":"id",
    "className" : "ScheduledTime",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the ScheduledTime
       * @property set {NUMBER} - sets the id of the ScheduledTime
       * @memberof ScheduledTime
       */
      BCMSRecordProperty.mapToString("id","_id"),

      /** 
       * @name type
       * @instance
       * @property get {NUMBER} - gets the type of the ScheduledTime
       * @property set {NUMBER} - sets the type of the ScheduledTime
       * @memberof ScheduledTime
       */
      BCMSRecordProperty.mapToString("type","_type"),

        /** 
       * @name type
       * @instance
       * @property get {STRING} - gets the value of the ScheduledTime, like "Central Standard Time"
       * @property set {STRING} - sets the value of the ScheduledTime, like "Central Standard Time"
       * @memberof ScheduledTime
       */
        BCMSRecordProperty.mapToString("hour","_hour"),

        /** 
       * @name type
       * @instance
       * @property get {STRING} - gets the value of the ScheduledTime, like "Central Standard Time"
       * @property set {STRING} - sets the value of the ScheduledTime, like "Central Standard Time"
       * @memberof ScheduledTime
       */
        BCMSRecordProperty.mapToString("minute","_minute"),

        /** 
       * @name type
       * @instance
       * @property get {STRING} - gets the value of the ScheduledTime, like "Central Standard Time"
       * @property set {STRING} - sets the value of the ScheduledTime, like "Central Standard Time"
       * @memberof ScheduledTime
       */
        BCMSRecordProperty.mapToString("timeOfDay","_timeOfDay"),

    ]  
})




